(function () {
  'use strict';

  const elementName = 'aa-custom-mega-menu';

  if (customElements.get(elementName)) return;

  class AACustomMegaMenu extends HTMLElement {
    connectedCallback() {
      if (this.dataset.bound === 'true') return;

      this.dataset.bound = 'true';

      this.header = this.closest(
        'archetype-custom-header'
      );

      this.surface = this.header?.querySelector(
        '.aa-header__surface'
      );

      this.desktopMenu = this.header?.querySelector(
        '.aa-header__desktop-menu'
      );

      this.pageWrapper = document.querySelector(
        '.page-wrapper'
      );

      this.backdrop = this.querySelector(
        '[data-aa-mega-backdrop]'
      );

      this.drawers = Array.from(
        this.querySelectorAll(
          '[data-aa-mega-drawer]'
        )
      );

      this.triggers = this.header
        ? Array.from(
            this.header.querySelectorAll(
              '[data-aa-mega-trigger]'
            )
          )
        : [];

      this.headerActionButtons = this.header
        ? Array.from(
            this.header.querySelectorAll(
              [
                '[data-aa-search-open]',
                '[data-wishlist-link]',
                '[data-cw-open-cart]'
              ].join(', ')
            )
          )
        : [];

      this.activeTrigger = null;
this.activeDrawer = null;
this.closeTimer = 0;
this.scrollFrame = 0;

      this.isPointerCoarse =
        window.matchMedia(
          '(hover: none), (pointer: coarse)'
        ).matches;

      this.handleDesktopPointerOver =
        this.handleDesktopPointerOver.bind(this);

      this.handleDesktopFocusIn =
        this.handleDesktopFocusIn.bind(this);

      this.handleDesktopClick =
        this.handleDesktopClick.bind(this);

      this.handleDesktopPointerLeave =
        this.handleDesktopPointerLeave.bind(this);

      this.handleNestedPointerOver =
        this.handleNestedPointerOver.bind(this);

      this.handleNestedFocus =
        this.handleNestedFocus.bind(this);

      this.handleNestedClick =
        this.handleNestedClick.bind(this);

      this.handleMenuPointerEnter =
        this.handleMenuPointerEnter.bind(this);

      this.handleMenuPointerLeave =
        this.handleMenuPointerLeave.bind(this);

      this.handleBackdropClick =
        this.handleBackdropClick.bind(this);
  
      this.handleBackdropPointerEnter =
        this.handleBackdropPointerEnter.bind(this);

      this.handleDocumentClick =
        this.handleDocumentClick.bind(this);

      this.handleDocumentFocus =
        this.handleDocumentFocus.bind(this);

      this.handleKeydown =
        this.handleKeydown.bind(this);

      this.handleResize =
        this.handleResize.bind(this);

      this.handleScroll =
        this.handleScroll.bind(this);

      this.handleHeaderActionClick =
        this.handleHeaderActionClick.bind(this);

      this.desktopMenu?.addEventListener(
        'pointerover',
        this.handleDesktopPointerOver
      );

      this.desktopMenu?.addEventListener(
        'focusin',
        this.handleDesktopFocusIn
      );

      this.desktopMenu?.addEventListener(
        'click',
        this.handleDesktopClick
      );

      this.desktopMenu?.addEventListener(
        'pointerleave',
        this.handleDesktopPointerLeave
      );

      this.addEventListener(
        'pointerover',
        this.handleNestedPointerOver
      );

      this.addEventListener(
        'focusin',
        this.handleNestedFocus
      );

      this.addEventListener(
        'click',
        this.handleNestedClick
      );

      this.addEventListener(
        'pointerenter',
        this.handleMenuPointerEnter
      );

      this.addEventListener(
        'pointerleave',
        this.handleMenuPointerLeave
      );

      this.backdrop?.addEventListener(
        'click',
        this.handleBackdropClick
      );

      this.backdrop?.addEventListener(
        'pointerenter',
        this.handleBackdropPointerEnter
      );

      document.addEventListener(
        'click',
        this.handleDocumentClick
      );

      document.addEventListener(
        'focusin',
        this.handleDocumentFocus
      );

      document.addEventListener(
        'keydown',
        this.handleKeydown
      );

      window.addEventListener(
        'resize',
        this.handleResize
      );

      window.addEventListener(
        'scroll',
        this.handleScroll,
        {
          passive: true
        }
      );

      this.pageWrapper?.addEventListener(
        'scroll',
        this.handleScroll,
        {
          passive: true
        }
      );

      this.headerActionButtons.forEach((button) => {
        button.addEventListener(
          'click',
          this.handleHeaderActionClick
        );
      });
    }

    disconnectedCallback() {
      this.cancelClose();
      if (this.scrollFrame) {
  window.cancelAnimationFrame(
    this.scrollFrame
  );

  this.scrollFrame = 0;
}

      this.desktopMenu?.removeEventListener(
        'pointerover',
        this.handleDesktopPointerOver
      );

      this.desktopMenu?.removeEventListener(
        'focusin',
        this.handleDesktopFocusIn
      );

      this.desktopMenu?.removeEventListener(
        'click',
        this.handleDesktopClick
      );

      this.desktopMenu?.removeEventListener(
        'pointerleave',
        this.handleDesktopPointerLeave
      );

      this.removeEventListener(
        'pointerover',
        this.handleNestedPointerOver
      );

      this.removeEventListener(
        'focusin',
        this.handleNestedFocus
      );

      this.removeEventListener(
        'click',
        this.handleNestedClick
      );

      this.removeEventListener(
        'pointerenter',
        this.handleMenuPointerEnter
      );

      this.removeEventListener(
        'pointerleave',
        this.handleMenuPointerLeave
      );

      this.backdrop?.removeEventListener(
        'click',
        this.handleBackdropClick
      );

      this.backdrop?.removeEventListener(
        'pointerenter',
        this.handleBackdropPointerEnter
      );

      document.removeEventListener(
        'click',
        this.handleDocumentClick
      );

      document.removeEventListener(
        'focusin',
        this.handleDocumentFocus
      );

      document.removeEventListener(
        'keydown',
        this.handleKeydown
      );

      window.removeEventListener(
        'resize',
        this.handleResize
      );

      window.removeEventListener(
        'scroll',
        this.handleScroll
      );

      this.pageWrapper?.removeEventListener(
        'scroll',
        this.handleScroll
      );

      this.headerActionButtons.forEach((button) => {
        button.removeEventListener(
          'click',
          this.handleHeaderActionClick
        );
      });
    }

    handleDesktopPointerOver(event) {
      if (window.innerWidth < 990) return;

      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      const trigger = target.closest(
        '[data-aa-mega-trigger]'
      );

      if (
        trigger &&
        this.desktopMenu?.contains(trigger)
      ) {
        this.cancelClose();

        if (
          this.activeTrigger !== trigger ||
          this.hidden
        ) {
          this.openForTrigger(trigger);
        }

        return;
      }

      const normalLink = target.closest(
        '.aa-header__menu-link'
      );

      if (
        normalLink &&
        this.desktopMenu?.contains(normalLink)
      ) {
        this.cancelClose();
        this.close();
      }
    }

    handleDesktopFocusIn(event) {
      if (window.innerWidth < 990) return;

      const target =
        event.target instanceof Element
          ? event.target
          : null;

      if (!target) return;

      const trigger = target.closest(
        '[data-aa-mega-trigger]'
      );

      if (
        trigger &&
        this.desktopMenu?.contains(trigger)
      ) {
        this.cancelClose();
        this.openForTrigger(trigger);
        return;
      }

      const normalLink = target.closest(
        '.aa-header__menu-link'
      );

      if (
        normalLink &&
        this.desktopMenu?.contains(normalLink)
      ) {
        this.close();
      }
    }

    handleDesktopClick(event) {
      if (window.innerWidth < 990) return;

      const target =
        event.target instanceof Element
          ? event.target
          : null;

      const trigger = target?.closest(
        '[data-aa-mega-trigger]'
      );

      if (
  !trigger ||
  !this.desktopMenu?.contains(trigger)
) {
  return;
}

/*
 * A mega-menu heading can optionally be an anchor.
 * Hover and keyboard focus still open its mega menu,
 * while clicking follows the assigned URL.
 */
if (
  trigger.matches(
    'a[data-aa-mega-clickable][href]'
  )
) {
  this.close();
  return;
}

event.preventDefault();

const alreadyOpen =
  this.activeTrigger === trigger &&
  !this.hidden;

      if (alreadyOpen) {
        this.close({
          returnFocus: trigger
        });

        return;
      }

      this.openForTrigger(trigger);
    }

    handleDesktopPointerLeave() {
      this.scheduleClose();
    }

    openForTrigger(trigger) {
      if (
        !trigger ||
        window.innerWidth < 990
      ) {
        return;
      }

      const drawerId = trigger.getAttribute(
        'data-aa-mega-drawer-id'
      );

      const drawer = this.drawers.find((item) => {
        return (
          item.getAttribute(
            'data-aa-drawer-id'
          ) === drawerId
        );
      });

      if (!drawer) return;

      if (
        this.activeTrigger === trigger &&
        this.activeDrawer === drawer &&
        !this.hidden
      ) {
        this.cancelClose();
        this.updateTopPosition();
        return;
      }

      this.cancelClose();
      this.updateTopPosition();

      this.triggers.forEach((item) => {
        const active = item === trigger;

        item.classList.toggle(
          'is-mega-active',
          active
        );

        item.setAttribute(
          'aria-expanded',
          active ? 'true' : 'false'
        );
      });

      this.drawers.forEach((item) => {
        const active = item === drawer;

        item.hidden = !active;

        if (!active) {
          this.resetDrawer(item);
        }
      });

      this.resetDrawer(drawer);

      this.activeTrigger = trigger;
      this.activeDrawer = drawer;

      this.hidden = false;

      this.header?.classList.add(
        'is-mega-open'
      );

      document.documentElement.classList.add(
        'aa-mega-menu-open'
      );
    }

    close(options = {}) {
      const wasOpen = !this.hidden;

      this.cancelClose();

      this.triggers.forEach((trigger) => {
        trigger.classList.remove(
          'is-mega-active'
        );

        trigger.setAttribute(
          'aria-expanded',
          'false'
        );
      });

      this.drawers.forEach((drawer) => {
        drawer.hidden = true;
        this.resetDrawer(drawer);
      });

      this.activeTrigger = null;
      this.activeDrawer = null;

      this.hidden = true;

      this.header?.classList.remove(
        'is-mega-open'
      );

      document.documentElement.classList.remove(
        'aa-mega-menu-open'
      );

      if (
        wasOpen &&
        options.returnFocus instanceof HTMLElement
      ) {
        options.returnFocus.focus({
          preventScroll: true
        });
      }
    }

    resetDrawer(drawer) {
      if (!drawer) return;

      drawer
        .querySelectorAll(
          '[data-aa-mega-column]'
        )
        .forEach((column) => {
          const level = Number(
            column.getAttribute(
              'data-aa-level'
            ) || 1
          );

          column.hidden = level !== 1;
        });

      drawer
        .querySelectorAll(
          '[data-aa-mega-node]'
        )
        .forEach((node) => {
          node.classList.remove(
            'is-active'
          );

          if (
            node.hasAttribute(
              'data-aa-has-children'
            )
          ) {
            node.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        });

      this.updateDrawerLayout(drawer);
    }

    activateNode(node) {
      const drawer = node.closest(
        '[data-aa-mega-drawer]'
      );

      if (
        !drawer ||
        drawer !== this.activeDrawer
      ) {
        return;
      }

      const level = Number(
        node.getAttribute(
          'data-aa-level'
        ) || 1
      );

      const nodeKey = node.getAttribute(
        'data-aa-node-key'
      );

      const hasChildren = node.hasAttribute(
        'data-aa-has-children'
      );

      drawer
        .querySelectorAll(
          '[data-aa-mega-node]'
        )
        .forEach((item) => {
          const itemLevel = Number(
            item.getAttribute(
              'data-aa-level'
            ) || 1
          );

          if (itemLevel >= level) {
            item.classList.remove(
              'is-active'
            );

            if (
              item.hasAttribute(
                'data-aa-has-children'
              )
            ) {
              item.setAttribute(
                'aria-expanded',
                'false'
              );
            }
          }
        });

      drawer
        .querySelectorAll(
          '[data-aa-mega-column]'
        )
        .forEach((column) => {
          const columnLevel = Number(
            column.getAttribute(
              'data-aa-level'
            ) || 1
          );

          if (columnLevel > level) {
            column.hidden = true;
          }
        });

      if (!hasChildren || !nodeKey) {
        this.updateDrawerLayout(drawer);
        return;
      }

      const nextColumn = Array.from(
        drawer.querySelectorAll(
          '[data-aa-mega-column]'
        )
      ).find((column) => {
        return (
          column.getAttribute(
            'data-aa-column-owner'
          ) === nodeKey
        );
      });

      if (!nextColumn) {
        this.updateDrawerLayout(drawer);
        return;
      }

      node.classList.add('is-active');

      node.setAttribute(
        'aria-expanded',
        'true'
      );

      nextColumn.hidden = false;

      this.updateDrawerLayout(drawer);
    }

    updateDrawerLayout(drawer) {
      if (!drawer) return;

      const visibleColumns = Array.from(
        drawer.querySelectorAll(
          '[data-aa-mega-column]'
        )
      ).filter((column) => {
        return !column.hidden;
      });

      const promotions = drawer.querySelector(
        '[data-aa-mega-promotions]'
      );

      const showPromotions =
        visibleColumns.length === 1 &&
        Boolean(promotions);

      if (promotions) {
        promotions.hidden =
          !showPromotions;

        promotions.setAttribute(
          'aria-hidden',
          showPromotions
            ? 'false'
            : 'true'
        );
      }

      const slotCount = showPromotions
        ? 2
        : Math.max(
            visibleColumns.length,
            1
          );

      const componentStyles =
        window.getComputedStyle(this);

      const configuredColumnWidth =
        parseFloat(
          componentStyles.getPropertyValue(
            '--aa-mega-column-width'
          )
        ) || 270;

      const configuredPanelWidth =
        parseFloat(
          componentStyles.getPropertyValue(
            '--aa-mega-panel-width'
          )
        ) || window.innerWidth;

      const availableWidth = Math.max(
        1,
        Math.min(
          configuredPanelWidth,
          window.innerWidth - 16
        )
      );

      const effectiveColumnWidth = Math.max(
        180,
        Math.min(
          configuredColumnWidth,
          availableWidth / slotCount
        )
      );

      drawer.style.setProperty(
        '--aa-visible-slots',
        String(slotCount)
      );

      drawer.style.setProperty(
        '--aa-effective-column-width',
        `${effectiveColumnWidth}px`
      );

      drawer.setAttribute(
        'data-visible-slots',
        String(slotCount)
      );

      drawer.classList.toggle(
        'is-showing-promotions',
        showPromotions
      );
    }

handleNestedPointerOver(event) {
  const target =
    event.target instanceof Element
      ? event.target
      : null;

  if (!target) return;

  /*
   * The user successfully reached the white drawer,
   * so cancel the pending backdrop close.
   */
  const drawer = target.closest(
    '[data-aa-mega-drawer]'
  );

  if (
    drawer &&
    drawer === this.activeDrawer
  ) {
    this.cancelClose();
  }

  const node = target.closest(
    '[data-aa-mega-node]'
  );

      if (
        !node ||
        !this.contains(node)
      ) {
        return;
      }

      const previousTarget =
        event.relatedTarget;

      if (
        previousTarget instanceof Node &&
        node.contains(previousTarget)
      ) {
        return;
      }

      this.cancelClose();
      this.activateNode(node);
    }

    handleNestedFocus(event) {
      const target =
        event.target instanceof Element
          ? event.target
          : null;

      const node = target?.closest(
        '[data-aa-mega-node]'
      );

      if (
        !node ||
        !this.contains(node)
      ) {
        return;
      }

      this.cancelClose();
      this.activateNode(node);
    }

    handleNestedClick(event) {
      if (
        window.innerWidth < 990 ||
        !this.isPointerCoarse
      ) {
        return;
      }

      const target =
        event.target instanceof Element
          ? event.target
          : null;

      const node = target?.closest(
        '[data-aa-mega-node]'
      );

      if (
        !node ||
        !node.hasAttribute(
          'data-aa-has-children'
        )
      ) {
        return;
      }

      const expanded =
        node.getAttribute(
          'aria-expanded'
        ) === 'true';

      if (!expanded) {
        event.preventDefault();
        this.activateNode(node);
      }
    }

    handleMenuPointerEnter() {
      this.cancelClose();
    }

    handleMenuPointerLeave() {
      this.scheduleClose();
    }

scheduleClose() {
  this.cancelClose();

  this.closeTimer = window.setTimeout(() => {
    const triggerHovered =
      this.activeTrigger?.matches(':hover');

    /*
     * Only the visible white drawer counts as being
     * inside the menu. The black backdrop does not.
     */
    const drawerHovered =
      this.activeDrawer?.matches(':hover');

    const activeElement =
      document.activeElement;

    const focusInsideTrigger =
      this.activeTrigger instanceof HTMLElement &&
      activeElement instanceof Node &&
      this.activeTrigger.contains(activeElement);

    const focusInsideDrawer =
      this.activeDrawer instanceof HTMLElement &&
      activeElement instanceof Node &&
      this.activeDrawer.contains(activeElement);

    if (
      !triggerHovered &&
      !drawerHovered &&
      !focusInsideTrigger &&
      !focusInsideDrawer
    ) {
      this.close();
    }
  }, 500);
}

    cancelClose() {
      window.clearTimeout(
        this.closeTimer
      );

      this.closeTimer = 0;
    }

handleBackdropPointerEnter() {
  if (
    window.innerWidth < 990 ||
    this.hidden
  ) {
    return;
  }

  this.scheduleClose();
}

    handleBackdropClick(event) {
      event.preventDefault();
      this.close();
    }

    handleDocumentClick(event) {
      if (this.hidden) return;

      const target = event.target;

      if (
        target instanceof Node &&
        (
          this.contains(target) ||
          this.activeTrigger?.contains(target)
        )
      ) {
        return;
      }

      this.close();
    }

    handleDocumentFocus(event) {
      if (this.hidden) return;

      const target = event.target;

      if (
        target instanceof Node &&
        (
          this.contains(target) ||
          this.activeTrigger?.contains(target)
        )
      ) {
        return;
      }

      this.scheduleClose();
    }

    handleKeydown(event) {
      if (
        event.key !== 'Escape' ||
        this.hidden
      ) {
        return;
      }

      event.preventDefault();

      const returnFocus =
        this.activeTrigger;

      this.close({
        returnFocus
      });
    }

    handleHeaderActionClick() {
      this.close();
    }

    handleResize() {
      this.isPointerCoarse =
        window.matchMedia(
          '(hover: none), (pointer: coarse)'
        ).matches;

      if (window.innerWidth < 990) {
        this.close();
        return;
      }

      if (!this.hidden) {
        this.updateTopPosition();

        if (this.activeDrawer) {
          this.updateDrawerLayout(
            this.activeDrawer
          );
        }
      }
    }

    handleScroll() {
  if (
    this.hidden ||
    window.innerWidth < 990
  ) {
    return;
  }

  if (this.scrollFrame) {
    return;
  }

  this.scrollFrame =
    window.requestAnimationFrame(() => {
      this.scrollFrame = 0;

      if (
        this.hidden ||
        window.innerWidth < 990
      ) {
        return;
      }

      /*
       * Keep the mega menu attached beneath
       * the sticky header instead of closing it.
       *
       * Scroll-locking the page can itself fire
       * a scroll event, so closing here causes
       * the menu to flash and disappear.
       */
      this.updateTopPosition();

      if (this.activeDrawer) {
        this.updateDrawerLayout(
          this.activeDrawer
        );
      }
    });
}

updateTopPosition() {
  if (!this.surface) return;

  const surfaceRect =
    this.surface.getBoundingClientRect();

  /*
   * Start one pixel over the header's bottom
   * edge so there is no visible gap.
   */
  const topPosition =
    Math.max(
      0,
      Math.floor(
        surfaceRect.bottom
      ) - 1
    );

  this.style.setProperty(
    '--aa-mega-top',
    `${topPosition}px`
  );
}
  }

  customElements.define(
    elementName,
    AACustomMegaMenu
  );
})();